var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldTextarea, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import * as React from 'react';
import { analytics } from 'app/utils/segment';
import { notificationActions } from 'components/notifications/actions/notification';
import { transferToAgentActions } from 'components/shared/transferToAgentModal/actions/transferToAgentModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import styles from './confirmTransferModal.module.scss';
export const ConfirmTransferModal = ({ isOpen, onClose, assignedAgent, transferToUser, metaConversation, }) => {
    const [message, setMessage] = useState('');
    const dispatch = useAppDispatch();
    const transferConversation = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            yield bindActionToPromise(dispatch, transferToAgentActions.transferToAgentBlindRequest)({
                requestToUser: { id: transferToUser.id },
                requestFromAgent: assignedAgent,
                metaConversation: metaConversation,
                message: message,
            });
            analytics.conversationTransferred({
                conversationId: (_a = metaConversation.conversation.id) !== null && _a !== void 0 ? _a : 0,
                option: 'agent',
            });
            setMessage('');
        }
        catch (error) {
            const csid = metaConversation.conversation.id;
            setMessage('');
            dispatch(transferToAgentActions.transferToAgentRequestStop({
                csid,
            }));
            dispatch(notificationActions.notificationAdd({
                title: 'Could not transfer the conversation',
                text: `An issue occurred while trying transfer conversation ${csid}.`,
                status: 'danger',
                icon: 'exclamation',
            }));
            console.warn(error);
        }
    });
    const handleOnClose = () => {
        setMessage('');
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleOnMessageChange = (event) => {
        if (!event) {
            return;
        }
        setMessage(event.target.value);
    };
    const handleOnKeyDown = (event) => {
        if (!event) {
            return;
        }
        if (event.key === 'Enter' && event.metaKey) {
            handleOnClose();
            transferConversation();
        }
    };
    const handleConfirmOnClick = () => {
        handleOnClose();
        transferConversation();
    };
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleOnClose }, { children: [_jsx(ModalHead, { title: `Transfer ${metaConversation.conversation.id} to ${transferToUser.name}`, onClose: onClose }), _jsx(ModalBody, Object.assign({ className: styles.messageModalBody }, { children: _jsx(FieldTextarea, { autoFocus: true, input: {
                        name: 'message',
                        value: message,
                        onChange: handleOnMessageChange,
                    }, label: "Transfer message", placeholder: `Write a message to ${transferToUser.name}...`, onKeyDown: handleOnKeyDown }) })), _jsx(ModalFoot, { confirmName: "Transfer", confirmOnClick: handleConfirmOnClick, cancelName: "Cancel transfer", cancelOnClick: handleOnClose })] })));
};
